class Auth {
  isAuthenticated() {
    if (
      sessionStorage.getItem("loggedIn")
    ) {
      return true;
    }else if( sessionStorage.getItem("idamLogin")==="true") {
     return true
    }else {
      return false;
    }
  }
}
export default new Auth();
